<template>
  <div id="app">
    <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests">
     <router-view></router-view>
      <div class="fix" @click="backtop" v-show="isTop"></div>
  </div>
</template>

<script>
  !function(p){"use strict";!function(t){var s=window,e=document,i=p,c="".concat("https:"===e.location.protocol?"https://":"http://","sdk.51.la/js-sdk-pro.min.js"),n=e.createElement("script"),r=e.getElementsByTagName("script")[0];n.type="text/javascript",n.setAttribute("charset","UTF-8"),n.async=!0,n.src=c,n.id="LA_COLLECT",i.d=n;var o=function(){s.LA.ids.push(i)};s.LA?s.LA.ids&&o():(s.LA=p,s.LA.ids=[],o()),r.parentNode.insertBefore(n,r)}()}({id:"JKJKnbh9Hx4R5GyY",ck:"JKJKnbh9Hx4R5GyY"});
  import header from "../../components/common/header.vue"
  import footer from "../../components/common/footer.vue"

  export default {
    name: "index",
    data() {
      return {
          input:null,
          code:null,
          isTop:false,
          scrollTop:null
      }
    },
    components:{
      "v-header": header,
      "v-footer": footer,
    },
      mounted() {
       
      },

    created(){
    
    },
      watch:{


      },
    methods:{
        // 显示回到顶部按钮
        showBtn(){
            let scrollTop = window.pageYOffset ;
            if(scrollTop>800){
                this.isTop = true
            }else {
                this.isTop = false
            }

        },
        backtop(){
            var timer = setInterval(function(){
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 2);
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                if(osTop === 0){
                    clearInterval(timer);
                }
            },40)
        }

    },
    

  }
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1800px;
 // text-align: center;
    background-color: #FAFAFA;
 //   overflow: hidden;
    .fix{
        position: fixed;
        right: 50px;
        bottom: 50px;
        width: 61px;
        height: 61px;
        background: url("../../assets/img/gotop.png");
    }
}


</style>
